<template>
  <div>
    <el-drawer
      :visible.sync="drawer"
      :close-on-press-escape="true"
      :wrapperClosable="true"
      size="50%"
      @close="closeDrawer"
    >
      <template slot="title">
        <div style="font-weight: bold; font-size: 18px">详情</div>
      </template>
      <div style="width: 100%; box-sizing: border-box; padding: 20px">
        <div class="title">
          <span style="margin-left: 20px">设备移交清单</span>
        </div>
        <div class="form">
          <el-form ref="form" :model="form" label-width="100px">
            <el-row style="border-bottom: 1px solid #ccc">
              <el-col :span="12">
                <el-form-item label="项目名称："></el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="文件编号："></el-form-item>
              </el-col>
            </el-row>
            <el-row style="border-bottom: 1px solid #ccc">
              <el-col :span="12">
                <el-form-item label="设备名称："></el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系人："></el-form-item>
              </el-col>
            </el-row>
            <el-row style="border-bottom: 1px solid #ccc">
              <el-col :span="12">
                <el-form-item label="日期："></el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话："></el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="info">
          <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item name="1">
              <template slot="title">
                <div
                  style="
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div style="font-size: 18px; font-weight: bold">
                    1.基本信息
                  </div>

                  <div style="display: flex; align-items: center">
                    <i class="el-icon-arrow-down" style="font-size: 30px"></i>
                    <!-- <i class="el-icon-arrow-up" style="font-size: 30px"></i> -->
                    <i
                      class="el-icon-circle-check"
                      style="font-size: 30px; color: #67c23a"
                    ></i>
                  </div>
                </div>
              </template>
              <div class="formInfo">
                <el-form ref="form" :model="form" label-width="200px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="设备名称："></el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="设备编号："></el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="设备规格："></el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="设备数量："></el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="购置日期："></el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="生产厂家名称"></el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="生产厂家联系人："></el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="生产厂家手机号："></el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="维修商："></el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="维修商联系人："></el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="维修商手机号："></el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>

            <el-collapse-item name="2">
              <template slot="title">
                <div
                  style="
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div style="font-size: 18px; font-weight: bold">
                    2.配置信息
                  </div>

                  <div style="display: flex; align-items: center">
                    <i class="el-icon-arrow-down" style="font-size: 30px"></i>
                    <!-- <i class="el-icon-arrow-up" style="font-size: 30px"></i> -->
                    <i
                      class="el-icon-circle-check"
                      style="font-size: 30px; color: #67c23a"
                    ></i>
                  </div>
                </div>
              </template>
              <el-form ref="form" :model="form" label-width="200px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="制冷量（kW/RT）："></el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="制热量（kW）："></el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="输入功率（kW）："></el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="能效比（COP/EER）："></el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="冷媒类型："></el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="水温："></el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-collapse-item>
            <el-collapse-item name="3">
              <template slot="title">
                <div
                  style="
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div style="font-size: 18px; font-weight: bold">
                    3.设备文档信息
                  </div>

                  <div style="display: flex; align-items: center">
                    <i class="el-icon-arrow-down" style="font-size: 30px"></i>
                    <!-- <i class="el-icon-arrow-up" style="font-size: 30px"></i> -->
                    <i
                      class="el-icon-circle-check"
                      style="font-size: 30px; color: #67c23a"
                    ></i>
                  </div>
                </div>
              </template>
              <el-table border :data="tableData">
                <el-table-column prop="name" label="文件类型"></el-table-column>
                <el-table-column prop="fileInfo" label="文件信息">
                  <template slot-scope="scope">
                    <div v-for="item in scope.row.list" :key="item.name">
                      {{ item.name }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="fileSize" label="文件大小">
                  <template slot-scope="scope">
                    <div
                      v-for="item in scope.row.list"
                      :key="item.name"
                      style="display: flex; justify-content: space-between"
                    >
                      <div>{{ item.name }}</div>
                      <div>{{ item.size }}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="status"
                  label="状态"
                  width="100px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <i
                      class="el-icon-circle-check"
                      style="font-size: 20px; color: #67c23a"
                      v-if="
                        scope.row.list?.length > 0 &&
                        scope.row.list?.every(
                          (item) => item.status === 'success'
                        )
                      "
                    ></i>
                    <i
                      v-else
                      class="el-icon-circle-close"
                      style="font-size: 20px; color: #f56c6c"
                    ></i>
                  </template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
            <el-collapse-item name="4">
              <template slot="title">
                <div
                  style="
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div style="font-size: 18px; font-weight: bold">
                    4.配件信息
                  </div>

                  <div style="display: flex; align-items: center">
                    <i class="el-icon-arrow-down" style="font-size: 30px"></i>
                    <!-- <i class="el-icon-arrow-up" style="font-size: 30px"></i> -->
                    <i
                      class="el-icon-circle-check"
                      style="font-size: 30px; color: #67c23a"
                    ></i>
                  </div>
                </div>
              </template>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      drawer: false,
      form: {},
      activeNames: [],
      tableData: [
        {
          name: '选型报告',

          fileSize: '100KB',
          status: true,
          list: [
            {
              name: '选型报告——2021-01-01.pdf',
              size: '200kb',
              url: 'http://192.168.1.100:8080/file/download?fileId=1',
              status: 'success',
            },
            {
              name: '选型报告——2021-09-01.pdf',
              size: '200kb',
              url: 'http://192.168.1.100:8080/file/download?fileId=1',
              status: 'success',
            },
          ],
        },
        {
          name: '3C认证',

          fileSize: '100KB',
          status: true,
          list: [
            {
              name: '3C认证——2021-01-01.pdf',
              size: '200kb',
              url: 'http://192.168.1.100:8080/file/download?fileId=1',
              status: 'success',
            },
            {
              name: '3C认证——2021-09-01.pdf',
              size: '200kb',
              url: 'http://192.168.1.100:8080/file/download?fileId=1',
              status: 'success',
            },
          ],
        },
      ],
    }
  },
  props: {},
  components: {},
  methods: {
    handleChange() {},
    closeDrawer() {
      this.drawer = false
    },
    openDrawer() {
      this.drawer = true
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #409eff;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
}
::v-deep .form .el-form-item {
  margin-bottom: 0px;
}
::v-deep .formInfo .el-form-item {
  margin-bottom: 10px;
}
::v-deep .el-form-item__label {
  font-size: 16px;
  color: #606266;
}
::v-deep .el-collapse-item__header {
  .el-icon-arrow-right {
    display: none;
  }
}
</style>
